// src/services/factory/index.js
import createCrudService from './createCrudService';

/**
 * Utility wrapper to create a service with human-readable name
 * @param {string} entityName - Human-readable entity name (e.g., 'Client')
 * @param {string} basePath - API base path for the entity (e.g., '/clients')
 * @param {Object} options - Additional options for createCrudService
 */
export const createService = (entityName, basePath, options = {}) => {
  return createCrudService({
    entityName,
    basePath,
    ...options
  });
};

/**
 * Creates file upload options for a entity service
 * @param {string} fieldName - Name of the file field in the form
 * @param {string} endpoint - API endpoint for file upload
 * @returns {Object} File upload configuration
 */
export const createFileUploadConfig = (fieldName = 'file', endpoint = 'file') => {
  return {
    enabled: true,
    fieldName,
    endpoint
  };
};

/**
 * Creates a related entity configuration
 * @param {string} name - Name of the related entity (e.g., 'brand')
 * @param {string} path - API path for the relationship (defaults to name)
 * @param {boolean} removable - Whether the relationship can be removed
 * @returns {Object} Related entity configuration
 */
export const createRelatedEntity = (name, path = null, removable = true) => {
  return {
    name,
    path: path || name,
    removable
  };
};

/**
 * Creates a nested collection configuration
 * @param {string} name - Plural name of the collection (e.g., 'tasks')
 * @param {string} singularName - Singular name (e.g., 'task')
 * @param {string} path - API path for the collection (defaults to name)
 * @param {boolean} orderable - Whether collection items can be reordered
 * @returns {Object} Nested collection configuration
 */
export const createNestedCollection = (name, singularName = null, path = null, orderable = false) => {
  return {
    name,
    singularName: singularName || name.slice(0, -1), // Default to name without 's'
    path: path || name,
    orderable
  };
};

// Export all utilities
export { 
  createCrudService as default,
  createCrudService
};